import React from 'react';
import { ExternalLink, Youtube } from 'lucide-react';

/**
 * Renders a horizontally scrollable strip of YouTube video previews.
 * Falls back to a "no videos" placeholder when empty.
 */
const VideoStrip = ({ videos, testIdPrefix = 'video' }) => {
  if (!videos || videos.length === 0) {
    return (
      <div className="text-xs text-gray-400 italic" data-testid={`${testIdPrefix}-empty`}>
        No YouTube videos returned for this lesson.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {videos.map((v) => (
        <a
          key={v.video_id}
          href={v.url}
          target="_blank"
          rel="noreferrer"
          className="group block rounded-lg border border-gray-200 hover:border-purple-300 bg-white overflow-hidden"
          data-testid={`${testIdPrefix}-${v.video_id}`}
        >
          <div className="relative aspect-video bg-gray-100">
            {v.thumbnail ? (
              <img
                src={v.thumbnail}
                alt={v.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <Youtube className="w-6 h-6" />
              </div>
            )}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
              <div className="w-12 h-12 rounded-full bg-red-600 flex items-center justify-center">
                <Youtube className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>
          <div className="p-3">
            <p className="text-sm font-medium text-gray-900 line-clamp-2">{v.title}</p>
            <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
              {v.channel}
              <ExternalLink className="w-3 h-3 ml-auto" />
            </p>
          </div>
        </a>
      ))}
    </div>
  );
};

export default VideoStrip;
